import {resolutionList} from "../constants/resolutions";

class DataStore {
  constructor() {
    this.dataCache = {};
    this.eventsCache = {};
  }

  /**
   * Stores event type of data. e.g., orders.
   * @param eventId   combination of widgetId and legend id. widgetId_legendId
   * @param events    event data. array or object
   */
  storeEvents(eventId, events) {

    if (!Array.isArray(events)) {
      events = [events];
    }

    const [widgetId, legendId] = eventId.split('_');
    events.forEach(e => {
      e.widgetId = widgetId;
      e.legendId = legendId
    });

    const cachedEvents = this.eventsCache[eventId] || [];
    const allEvents = [...cachedEvents, ...events];
    const removedDuplicatedTimeEvents = {};
    allEvents.forEach(e => {
      if (removedDuplicatedTimeEvents[e.eventId] === undefined) {
        removedDuplicatedTimeEvents[e.eventId] = e;
      }
    });
    this.eventsCache[eventId] = Object.values(removedDuplicatedTimeEvents).sort((a, b) => b.timestamp - a.timestamp);
    console.group('Store events');
    console.log(events);
    console.log(this.eventsCache);
    console.groupEnd()
  }

  emptyEvents(eventPrefix) {
    Object.keys(this.eventsCache).forEach(key => {
      if (key.indexOf(eventPrefix) > -1) {
        delete this.eventsCache[key];
      }
    });
    console.group('Empty events');
    console.log(this.eventsCache);
    console.groupEnd()
  }

  emptyAllEvents() {
    console.log('Empty all events');
    this.eventsCache = {};
  }

  getEventsByTime(eventId, startTime, endTime) {
    const eventData = this.eventsCache[eventId];
    if (eventData) {
      const events = eventData.filter(d => d.timestamp >= startTime && d.timestamp <= endTime);
      return JSON.parse(JSON.stringify(events));
    }
    return [];
  }

  store(datasetId, data) {
    if (data && data.timestamp) {
      let copy = Object.assign({}, data);
      if (this.dataCache[datasetId]) {
        if (this.dataCache[datasetId].timestamp <= data.timestamp) {
          this.dataCache[datasetId] = copy;
        }
      } else {
        this.dataCache[datasetId] = copy
      }
    }
  }

  get(datasetId, resolution) {
    const identifier = resolution && resolution[4] !== 'tick' ? `${datasetId}@${resolution[4]}` : datasetId;
    let copy = null;
    if (this.dataCache[identifier]) {
      copy = Object.assign({}, this.dataCache[identifier]);
    }
    return copy;
  }

  remove(datasetId) {
    if (this.dataCache.hasOwnProperty(datasetId)) {
      delete this.dataCache[datasetId];
    }
  }
}

const instance = new DataStore();
export default instance;



// WEBPACK FOOTER //
// ./src/core/stores/dataStore.js